import { render, staticRenderFns } from "./MpAccount.vue?vue&type=template&id=1985a526&scoped=true&"
import script from "./MpAccount.vue?vue&type=script&lang=js&"
export * from "./MpAccount.vue?vue&type=script&lang=js&"
import style0 from "./MpAccount.vue?vue&type=style&index=0&id=1985a526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985a526",
  null
  
)

export default component.exports